<template>
  <div id="hello">
    <img :src="starter" id="starter">
  </div>
</template>

<script>
import starter from '@/assets/startbild.png'
export default {
  name: 'Index',
  data () {
    return {
      welcome: 'Welcome to schuett-biotec',
      starter: starter
    }
  },
  methods: {

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  text-decoration: circle;
  color: #fff;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #fc0c00;
}
#hello {
  text-align: center;
  background-color: black;
  margin-top: -10px;
}

#starter{
  -moz-animation-iteration-count: 1;
  -moz-animation-name: fly-in;
  -moz-animation-timing-function: ease-in;
  -moz-animation-duration: 2s;

  -webkit-animation-iteration-count: 1;
  -webkit-animation-name: fly-in;
  -webkit-animation-timing-function: ease-in;
  -webkit-animation-duration: 2s;

  animation-iteration-count: 1;
  animation-name: fly-in;
  animation-timing-function: ease-in;
  animation-duration: 2s;

  visibility: visible;
  max-height: 70vh;
}

#starter::before{
  visibility: hidden;
}

@keyframes fly-in {
  0% { transform: scale(3,3); }
  1% { visibility: visible; }
  100% { transform: scale(1,1); }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue